"use client"
export const CART_KEY = "isomorphic-cart";
export const POS_CART_KEY = "isomorphic-pos-cart";
export const DUMMY_ID = "FC6723757651DB74";
export const CHECKOUT = "isomorphic-checkout";
export const CURRENCY_CODE = "USD";
export const LOCALE = "en";
import useFetch from "@/hooks/fetch/useFetch";
import { apis } from "@/static/apis/apis";
import { StateType } from "@/types/global";
import useAxiosAuth from "@/hooks/fetch/useAxiosAuth";
export const CURRENCY_OPTIONS = {
  formation: "en-US",
  fractions: 2,
};

import getData from "@/functions/getData";

export const ROW_PER_PAGE_OPTIONS = [
  {
    value: 5,
    name: "5",
  },
  {
    value: 10,
    name: "10",
  },
  {
    value: 15,
    name: "15",
  },
  {
    value: 20,
    name: "20",
  },
];

export const ROLES = {
  Administrator: "Administrator",
  Manager: "Manager",
  Support: "Support",
  Developer: "Developer",
  RestrictedUser: "Restricted User",
  Customer: "Customer",
  SuperAdmin:"SuperAdmin"
} as const;
